
<div class="col-md-12 mb-30" [hidden]="WindowsSwitcher_Indexer!='List'">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0">اطلاعات  مشتریان </h5>
     <br/>
     <br>
      <div class="row">
        <div class="col-md-4">
          <div class="card card-statistics h-100">
            <div class="card-body">
              <div class="clearfix">
                <div class="float-left icon-box bg-success rounded-circle">
                  <span class="text-white">
                    <i class="fa fa-vcard highlight-icon" aria-hidden="true"></i>
                  </span>
                </div>
                <div class="float-right text-right">
                  <p class="card-text text-dark">	تعداد مشتریان </p>
                  <h4>{{total}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card card-statistics h-100">
            <div class="card-body">
              <div class="clearfix">
                <div class="float-left icon-box bg-info rounded-circle">
                  <span class="text-white">
                    <i class="fa fa-vcard highlight-icon" aria-hidden="true"></i>
                  </span>
                </div>
                <div class="float-right text-right">
                  <p class="card-text text-dark"> 	تعداد تعاریف <b>ماه جاری</b></p>
                  <h4>{{current_Month_create}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card card-statistics h-100">
            <div class="card-body">
              <div class="clearfix">
                <div class="float-left icon-box bg-warning rounded-circle">
                  <span class="text-white">
                    <i class="fa fa-vcard highlight-icon" aria-hidden="true"></i>
                  </span>
                </div>
                <div class="float-right text-right">
                  <p class="card-text text-dark"> تعداد ویرایش  <b>ماه جاری</b> </p>
                  <h4>{{current_Month_update}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br>
      <br>
     <br/>
     <div class="row">
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">بازه زمانی</label>
        <select class="custom-select" [(ngModel)]="SubmitPeriodDate" name="SubmitPeriodDate">
          <option value="1">اعمال شود</option>
          <option value="0">اعمال نشود</option>
        </select>
      </div>
      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">تاریخ شروع</label>
        <input type="text" #datepickerInputStart placeholder="اینجا تایپ کنید ..."   class="form-control" />
        <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
      </div>
      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">تاریخ پایان</label>
        <input type="text" #datepickerInputEnd  placeholder="اینجا تایپ کنید ..."  class="form-control" />
        <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
      </div>
    </div>
     <div class="row">
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">نام مشتری  </label>
        <input [(ngModel)]="Name" type="text" class="form-control"  placeholder="برای جستجوی اینجا تایپ کنید ...">

      </div>
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">زمینه فعالیت</label>
        <select class="custom-select" [(ngModel)]="FeildActivityId">
          <option value="0">انتخاب کنید</option>
          <option *ngFor="let item of DataList_FeildActivity" [value]="item.id">{{item.title}}</option>
        </select>
      </div>
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">استان </label>
        <select class="custom-select" [(ngModel)]="ProvinceId"  (change)="ProvinceChange()">
          <option value="0">انتخاب کنید</option>
          <option *ngFor="let item of DataList_Province" [value]="item.code">{{item.title}}</option>
        </select>
      </div>
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">شهرستان</label>
        <select class="custom-select" [(ngModel)]="CityId" >
          <option value="0">انتخاب کنید</option>
          <option *ngFor="let item of DataList_City" [value]="item.id">{{item.title}}</option>
        </select>
      </div>
    </div>
     <div class="row">
      <div  class="form-group col-md-6" >
        <button *ngIf="!Procssing" type="button" (click)="ReadData_Customer(datepickerInputStart.value,datepickerInputEnd.value)"  class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
     </div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نام مشتری</th>
              <th>کد مشتری</th>
              <th>شناسه ملی</th>
              <th>وضیعت</th>
              <th>ایجاد کننده</th>
              <th>تاریخ ایجاد</th>
              <th>ویرایش کننده</th>
              <th>تاریخ ویرایش</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Customer
            | paginate
                    : {
                        id: 'DataList_Customer',
                        itemsPerPage: 100,
                        currentPage: page,
                        totalItems: (DataList_Customer).length
                      }
            " [ngClass]="{'Special': item.special}">
             <td>{{DataList_Customer.indexOf(item)+1}}</td>
              <td>{{item.name}}</td>
              <td>{{item.code}}</td>
              <td>{{item.shenasehMeli}}</td>
              <td>
                <p *ngIf="!item.del" style="color: #489b39;">فعال</p>
                <p *ngIf="item.del" style="color: crimson;">غیر فعال</p>
              </td>
              <td>{{item.create_user}} </td>
              <td>{{item.create_date}} </td>
              <td>{{item.update_user}} </td>
              <td>{{item.update_date}} </td>
              <td>
                <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          امکانات
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                          <a class="dropdown-item" style="cursor: pointer;" (click)="setCustomerForEdit(item)"><i class="fa fa-edit"></i> ویرایش </a>
                      </div>
                  </div>

                  <div *ngIf="item.DeletingProccess" >
                    <img  src="assets/Loading.gif" style="width: 25px;" />
                  </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_Customer"
     nextLabel="بعدی"
     previousLabel="قبلی"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>

<div *ngIf="WindowsSwitcher_Indexer=='Form'">

  <app-CustomerEditUser [EditRecord]="Selected_Customer_Record.id">

  </app-CustomerEditUser >
  <button (click)="BackToList()" type="button" class="btn btn-warning"><i
    class="fa fa-mail-reply"></i> بازگشت </button>

</div>